import { AHIcon, AHText, AHTextFonts, StoreFormattedDate } from "arkh";
import { StoreFormattedDate$key } from "arkh/src/common/__generated__/StoreFormattedDate.graphql";
import React from "react";

export function TodoListItemDeadline(props: {
  expireAtFormatted?: StoreFormattedDate$key | null;
  isExpired: boolean;
}) {
  if (!props.expireAtFormatted) {
    return null;
  }

  const tint = props.isExpired ? "status-negative" : "text-secondary";
  return (
    <>
      <AHIcon type="deadline" size="xsmall" color={tint} spaceRight="xsmall" />
      <AHText
        numberOfLines={1}
        color={tint}
        type="body"
        font={AHTextFonts.MEDIUM}
      >
        <StoreFormattedDate date={props.expireAtFormatted} />
      </AHText>
    </>
  );
}
